import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuthState } from "./AuthContext";

export function AuthGate({ children }: { children: ReactNode }) {
  const auth = useAuthState();
  const location = useLocation();

  if (auth.status === "loading") {
    return (
      <div role="status" aria-live="polite" style={{ padding: "var(--space-5)" }}>
        読み込み中...
      </div>
    );
  }

  if (auth.status === "unauthenticated") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
